import React from "react";
import { Link } from "react-router-dom";
import Logo from "../Assest/images/logo/logo.png";
import Payment from "../Assest/images/trading/payment-logo.png";
import { FaMapMarkerAlt } from "react-icons/fa";

import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaSquareInstagram } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="footer_footerContainer__UxOS_ pt-5 pb-0">
      <div className="container">
        <div className="row">
          <div className="col-md-4 ">
            <div className="footer_footer-logo___GXmG">
              <img className="w-25" src={Logo} alt="" />

              <p className="text-white mt-3 mb-1">
                Praansh Healthcare, a unit of Together Global Ventures Limited
                (TGVL)
              </p>

              <p className="text-white mt-3">
                <FaMapMarkerAlt className="me-2" />C -1/ 4&5, Rama Park, Opp.{" "}
                <br /> Metro Pillar No. 773, Near Dwarka <br /> Mor Metro
                Station{" "}
              </p>
              <p className="text-white mb-0">
                {" "}
                <FaPhoneAlt className="me-2" />
                +91 9891316160{" "}
              </p>
              <p className="text-white">
                <MdEmail className="me-2" /> tarunbansal@tgvl.in
              </p>
            </div>
          </div>
          {/* ACCOUNT */}
          <div className="col-md-2 col-6 footer_column__n1vnn">
            <h3 className="footer_footerTitle__E8s7L">ACCOUNT</h3>
            <div className="footer_links__6Y0fX">
              <Link to="#">Our Policies</Link>
              <Link to="/Profile">My Account</Link>
              <Link to="/signup">Create an Account</Link>
            </div>
          </div>

          {/* ABOUT */}

          <div className="col-md-2 col-6 footer_column__n1vnn">
            <h3 className="footer_footerTitle__E8s7L">Important link</h3>
            <div className="footer_links__6Y0fX">
              <Link to="/about-us">About Us</Link>
              {/* <Link to="/blogs">Blog</Link> */}
              <Link to="/contact-us">Contact Us</Link>
            </div>
          </div>

          {/* USEFUL LINKS */}

          {/* EYEGLASSES */}
          <div className="col-md-2 col-6 footer_column__n1vnn">
            <Link to="/eyeglasses" className="footer_footerTitle__E8s7L">
              EYEGLASSES
            </Link>
            <div className="footer_links__6Y0fX">
              <Link to="#">Men</Link>
              <Link to="#">Women</Link>
              <Link to="#">Kids</Link>
            </div>
          </div>

          {/* SUNGLASSES */}
          <div className="col-md-2 col-6 footer_column__n1vnn">
            <Link to="/sunglasses" className="footer_footerTitle__E8s7L">
              SUNGLASSES
            </Link>
            <div className="footer_links__6Y0fX">
              <Link to="#">Men</Link>
              <Link to="#">Women</Link>
            </div>
          <div className="Footer-socialmedia">
            <p className="footer_dwn-title__QkXa1">Follow us on:</p>
            <div className="footer_footerSocial__heA29">
              <Link to="#">
                <FaSquareInstagram />
              </Link>

              <Link to="#">
                <FaFacebook />
              </Link>

              <Link to="#">
                <FaXTwitter />
              </Link>
            </div>
          </div>
          </div>
          {/* CONTACT LENSES */}
        </div>

        {/* FOOTER BOTTOM */}
        <div className="row footer_footerTitan__Yikgy text-center pt-lg-5 pt-0 ">
          <p className="footer_copyright__qzQ1x  text-white">
            © 2026 TGVL Company Limited. All Rights Reserved.
          </p>
        </div>
      </div>

      {/* WhatsApp FlatIcon */}
      <a
        href="https://wa.me/9891926161" // apna number daalo
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-icon"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
    </footer>
  );
};

export default Footer;
